import TabsHeader from 'components/tabs-header';
import Breadcrumbs from 'components/breadcrumbs';
import { BarChart2 } from 'lucide-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const BenchmarkAnalyticsTabsHeader: React.FC = () => {
  return (
    <TabsHeader
      tabs={[
        {
          hasAccess: true,
          label: <FormattedMessage id="features.benchmarkAnalytics" />,
          to: '/benchmark-analytics',
        },
      ]}
      utils={<Breadcrumbs />}
      icon={<BarChart2 size={25} color="white" />}
    />
  );
};

export default React.memo(BenchmarkAnalyticsTabsHeader);